import React from "react";
import { cn } from "@/lib/utils";

/**
 * Section — consistent vertical rhythm + container.
 * Use `bleed` if the section needs a full-bleed background and you'll add your own container inside.
 */
const Section = ({
  as: Tag = "section",
  size = "md",
  bleed = false,
  className = "",
  children,
  innerClassName = "",
  id,
  testId,
  ...rest
}) => {
  const sizeClass = size === "sm" ? "section-y-sm" : size === "lg" ? "py-24 md:py-32" : "section-y";

  if (bleed) {
    return (
      <Tag id={id} data-testid={testId} className={cn("relative", sizeClass, className)} {...rest}>
        {children}
      </Tag>
    );
  }

  return (
    <Tag id={id} data-testid={testId} className={cn("relative", sizeClass, className)} {...rest}>
      <div className={cn("container-page", innerClassName)}>{children}</div>
    </Tag>
  );
};

export default Section;
